import { render, staticRenderFns } from "./BaseDropdownContent.vue?vue&type=template&id=98949a0c"
import script from "./BaseDropdownContent.vue?vue&type=script&lang=js"
export * from "./BaseDropdownContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports